// Organization management constants
export const ORGANIZATION_TYPES = {
  BUSINESS: 'BUSINESS',
  AGENCY: 'AGENCY'
}

export const ORGANIZATION_TYPE_OPTIONS = [
  { value: ORGANIZATION_TYPES.BUSINESS, label: 'BUSINESS' },
  { value: ORGANIZATION_TYPES.AGENCY, label: 'AGENCY' }
]

export const USER_ROLE_TYPES = {
  BUSINESS: 'BUSINESS',
  AGENCY: 'AGENCY'
}

export const USER_ROLE_DISPLAY_NAMES = {
  [USER_ROLE_TYPES.BUSINESS]: '비즈니스',
  [USER_ROLE_TYPES.AGENCY]: '에이전시'
}

export const USER_ROLE_BADGE_CLASSES = {
  [USER_ROLE_TYPES.BUSINESS]: 'badge-primary',
  [USER_ROLE_TYPES.AGENCY]: 'badge-info'
}

export const USER_ROLE_OPTIONS = [
  { value: USER_ROLE_TYPES.BUSINESS, label: '비즈니스' },
  { value: USER_ROLE_TYPES.AGENCY, label: '에이전시' }
]